import { StepStatus } from 'src/graphql/types/steps'
import { formatSnakeValue } from 'src/lib/formatters'

export class StepStatusOptions {
  static all(): StepStatus[] {
    return Object.values(StepStatus)
  }

  static labeled(): { label: string; value: StepStatus }[] {
    return this.all().map((value) => ({
      label: formatSnakeValue(value),
      value,
    }))
  }
}

